<template>
  <div class="content">
    <div class="content__row">
      <div class="content__column content__column--wide">
        <h1 class="content__title">Cupones de descuento</h1>
      </div>
    </div>
    <div class="content__row">
      <cupon-list :filters="filters"></cupon-list>
      <cupon-view
        :cupon="cupon"
        v-if="cuponAction === 'view' && cupon"
      ></cupon-view>
      <cupon-edit
        @new="newCupon"
        :cupon="cupon"
        v-if="cuponAction === 'edit'"
        :key="key"
      ></cupon-edit>
      <div class="content__column content__column--small">
        <h1 class="content__title">Opciones</h1>
        <div class="information">
          <h2 class="content__subtitle">Filtro</h2>

          <div class="form__container">
            <label for="search" class="form__label">búsqueda Libre</label>
            <input
              type="text"
              name="search"
              id="search"
              class="form__input"
              v-model="search"
              @keyup="setFilters"
            />
          </div>

          <div class="form__container">
            <label class="form__label form__label--required" for="status_id"
              >Filtrar por estatus</label
            >
            <div class="form__select-container">
              <select
                name="status_id"
                id="status_id"
                class="form__select"
                v-model="status_id"
                @change="setFilters"
              >
                <option :value="null">Cualquier estatus</option>
                <option
                  v-for="(status, index) in cuponStatus"
                  :key="index"
                  :value="status.id"
                  v-text="status.name"
                ></option>
              </select>
            </div>
          </div>

          <div class="form__container">
            <label class="form__label form__label--required" for="type_id"
              >Filtrar por tipo</label
            >
            <div class="form__select-container">
              <select
                name="type_id"
                id="type_id"
                class="form__select"
                v-model="type_id"
                @change="setFilters"
              >
                <option :value="null">Todos los tipos</option>
                <option
                  v-for="(type, index) in cuponTypes"
                  :key="index"
                  :value="type.id"
                  v-text="type.name"
                ></option>
              </select>
            </div>
          </div>

          <div class="form__container">
            <label class="form__label form__label--required" for="usage_id"
              >Filtrar por uso</label
            >
            <div class="form__select-container">
              <select
                name="usage_id"
                id="usage_id"
                class="form__select"
                v-model="usage_id"
                @change="setFilters"
              >
                <option :value="null">Todos los usos</option>
                <option
                  v-for="(usage, index) in cuponUsages"
                  :key="index"
                  :value="usage.id"
                  v-text="usage.name"
                ></option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button @click.prevent="newCupon" class="btn btn__add">Agregar</button>
  </div>
</template>

<script>
import httpService from "@/core/api/request";
import cuponList from "./list";
import cuponView from "./view";
import cuponEdit from "./edit";
import Mixins from "./mixins";
export default {
  mixins: [httpService, Mixins],
  components: {
    cuponList,
    cuponView,
    cuponEdit
  },
  data: function() {
    return {
      key: 0,
      search: null,
      status_id: null,
      type_id: null,
      usage_id: null,
      filters: undefined,
      cuponAction: null,
      cupon: null
    };
  },
  created: function() {
    this.getCuponStatus();
    this.getCuponTypes();
    this.getCuponUsages();
  },
  mounted: function() {
    this.$on("view", id => {
      this.getCupon(id, "view");
    });
    this.$on("edit", id => {
      this.getCupon(id, "edit");
    });
  },
  methods: {
    setFilters: function() {
      let filter = "";
      if (this.search && this.search.length > 1) {
        filter = filter + "&search=" + this.search;
      }
      if (this.status_id) {
        filter = filter + "&status_id=eq:" + this.status_id;
      }
      if (this.type_id) {
        filter = filter + "&type_id=eq:" + this.type_id;
      }
      if (this.usage_id) {
        filter = filter + "&usage_id=eq:" + this.usage_id;
      }
      filter = filter.replace(/(^&+|&+$)/, "");
      if (filter.length > 0) {
        this.filters = filter;
      } else {
        this.filters = undefined;
      }
    },
    getCupon: function(id, action) {
      this.cuponAction = action;
      let httpRequest = {
        params: "",
        module: "discount_cupons"
      };
      this.getById(id, httpRequest).then(cupon => {
        cupon.data.expiration_date = new Date(cupon.data.expiration_date);
        this.cupon = cupon.data;
      });
    },
    newCupon: function() {
      this.cupon = undefined;
      this.key = ++this.key;
      this.cuponAction = "edit";
    }
  }
};
</script>

<style lang="sass">
@import "../../assets/sass/components/_home"
@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/discount_cupons/cupons.vue